import { addMonths, subMonths, format } from "date-fns";
import { useMemo, useState, useEffect } from "react";
import { createMonth, createWeeksOfMonth } from "../core/calendar";

function useCalendar() {
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const title = document.getElementsByTagName("title")[0];
    if (!title) {
      return;
    }
    title.innerHTML = `Timesheet ${format(selectedDate, "yy/MM")}`;
  }, [selectedDate]);

  const currentMonthData = useMemo(
    () => createMonth(selectedDate.getFullYear(), selectedDate.getMonth()),
    [selectedDate]
  );

  const currentWeekData = useMemo(
    () =>
      createWeeksOfMonth(selectedDate.getFullYear(), selectedDate.getMonth()),
    [selectedDate]
  );

  return {
    currentMonthData,
    currentWeekData,

    nextMonth() {
      setSelectedDate(addMonths(selectedDate, 1));
    },

    prevMonth() {
      setSelectedDate(subMonths(selectedDate, 1));
    },

    selectedDate,
    setSelectedDate,
  };
}

export default useCalendar;
